module.exports = __webpack_public_path__ + "static/comprehensive-image-customize-9d0c0306ddad7e3e6da27600cbad5496.png";